export default "__VITE_PUBLIC_ASSET__6c88a254__"